import React, { useCallback, useEffect, useState } from 'react';
import { ModuleSlot } from '../../module-system/ModuleSlot.jsx';
import { requestJson } from '../../module-system/api.js';

export function VerificationHistory({ token, profileId, canView = false, onChanged, definitions }) {
  const scope = `${token || ''}:${profileId || ""}`;
  const [state, setState] = useState({ scope: null, items: [], error: '', loading: true });
  const [revision, setRevision] = useState(0);
  const canRead = Boolean(token && profileId && canView);
  useEffect(() => {
    let active = true;
    setState({ scope, items: [], error: '', loading: canRead });
    if (canRead) {
      requestJson(`/admin/profile/${encodeURIComponent(profileId)}/verifications`, { token }).then((payload) => {
        if (active) setState({ scope, items: Array.isArray(payload?.items) ? payload.items : [], error: '', loading: false });
      }).catch((error) => {
        if (active) setState({ scope, items: [], error: error.message || 'Could not load verification history.', loading: false });
      });
    }
    return () => { active = false; };
  }, [scope, canRead, token, profileId, revision]);
  const changed = useCallback(() => {
    setRevision((value) => value + 1);
    onChanged?.();
  }, [onChanged]);
  if (!canRead) return null;
  const items = state.scope === scope ? state.items : [];
  return (
    <section className="card card-body mb-3" aria-label="External verification">
      <h3 className="h5">Verification history</h3>
      {state.scope === scope && state.loading ? <p className="text-muted">Loading verification history…</p> : null}
      {state.scope === scope && state.error ? <div className="alert alert-danger" role="alert">{state.error}</div> : null}
      {items.length ? <div className="table-responsive"><table className="table table-sm">
        <thead><tr><th>Provider</th><th>Status</th><th>Started</th></tr></thead>
        <tbody>{items.map((item) => <tr key={item.id}><td>{item.providerLabel}</td><td>{item.status}</td><td>{new Date(item.createdAt).toLocaleString()}</td></tr>)}</tbody>
      </table></div> : <p className="text-muted">No external verifications yet.</p>}
      <ModuleSlot name="profile.verification.actions" token={token} definitions={definitions} profileId={profileId} history={items} onChanged={changed} />
    </section>
  );
}
